import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7af5c2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "loading-container"
}
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }

import { ArmyDTO } from "@/interfaces/Army";
import { RequesListaDTO } from "@/interfaces/Lista";
import { getlista } from "@/services/ListasService";
import { appsettings } from "@/settings/appsettings";
import { ejercitoPorNombre } from "@/utils/ejercitoLiga";
import { uploadImageToCloudinary } from "@/services/CloudinaryService";
import { ref, watch, onMounted, computed } from "vue";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalLista',
  props: {
    isVisible: { type: Boolean },
    hasLista: { type: Boolean },
    idInscripcion: {},
    ejercitoFijo: {}
  },
  emits: ["update:isVisible", "enviarLista", "modificarLista"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const internalIsVisible = ref(props.isVisible);
const isLoading = ref<boolean>(false);
const hasLista = ref<boolean>(false);

const imageBase64 = ref<string | null>(null);
const fileInput = ref<HTMLInputElement | null>(null);
const ejercitoSelected = ref<ArmyDTO>();
const listadoEjercitos = ref<ArmyDTO[]>([]);
const loadingEjercitos = ref<boolean>(false);
const isSendButtonDisabled = computed(() => {
  return !ejercitoSelected.value || !imageBase64.value;
});

const rules = {
  required: (value: string | null) => !!value || "Este campo es obligatorio.",
};

const loadEjercitos = async () => {
  isLoading.value = true;
  loadingEjercitos.value = true;

  listadoEjercitos.value = await appsettings.armies;

  isLoading.value = false;
  loadingEjercitos.value = false;
};

const onImageSelected = async (event: Event) => {
  const file = (event.target as HTMLInputElement).files?.[0];
  if (file) {
    isLoading.value = true;
    try {
      imageBase64.value = await uploadImageToCloudinary(file);
    } catch (error) {
      console.error("Error al subir la imagen:", error);
    } finally {
      isLoading.value = false;
    }
  }
};

const cambiarImagen = () => {
  if (fileInput.value) {
    fileInput.value.value = "";
  }
  imageBase64.value = null;
  internalIsVisible.value = true;
};

watch(
  () => props.isVisible,
  newVal => {
    internalIsVisible.value = newVal;
  }
);

watch(
  () => props.hasLista,
  async newVal => {
    if (newVal) {
      isLoading.value = true;
      try {
        const response = await getlista(props.idInscripcion);
        imageBase64.value = response.data.listaData;
      } catch {
        console.error("No se ha podido cargar la lista");
      } finally {
        isLoading.value = false;
      }
    }
  }
);

// eslint-disable-next-line no-undef
const emit = __emit;

const close = () => {
  emit("update:isVisible", false);
  internalIsVisible.value = false;
};

const enviarLista = () => {
  if (imageBase64.value == null || ejercitoSelected.value == null) return;
  const newLista: RequesListaDTO = {
    listaData: imageBase64.value,
    ejercito: ejercitoSelected.value,
    idUsuario: 0,
    nick: "",
  };
  if (hasLista.value) emit("modificarLista", newLista);
  else emit("enviarLista", newLista);

  imageBase64.value = "";
  ejercitoSelected.value = props.ejercitoFijo
    ? ejercitoPorNombre(props.ejercitoFijo)
    : undefined;
};

onMounted(async () => {
  isLoading.value = true;
  try {
    const response = await getlista(props.idInscripcion);

    imageBase64.value = response.data.listaData;
    ejercitoSelected.value = response.data.ejercito;
    if (imageBase64.value != null) hasLista.value = true;
  } catch {
    console.error("No se ha podido cargar la lista");
  } finally {
    if (props.ejercitoFijo)
      ejercitoSelected.value = ejercitoPorNombre(props.ejercitoFijo);
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: internalIsVisible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((internalIsVisible).value = $event)),
    "max-width": "500"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "headline" }, {
            default: _withCtx(() => [
              _createTextVNode("Tu lista")
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_combobox, {
                modelValue: ejercitoSelected.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ejercitoSelected).value = $event)),
                items: listadoEjercitos.value,
                "item-title": "name",
                label: 
            _ctx.ejercitoFijo ? 'Ejército de la liga' : '¿Cuál es tu ejército principal?'
          ,
                disabled: !!_ctx.ejercitoFijo,
                hint: _ctx.ejercitoFijo ? 'En la liga juegas siempre con este ejército' : '',
                "persistent-hint": !!_ctx.ejercitoFijo,
                onClick: loadEjercitos,
                rules: [rules.required],
                required: ""
              }, null, 8, ["modelValue", "items", "label", "disabled", "hint", "persistent-hint", "rules"]),
              (loadingEjercitos.value)
                ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                    key: 0,
                    indeterminate: "",
                    color: "primary",
                    class: "progress-linear-margin"
                  }))
                : _createCommentVNode("", true),
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      color: "primary"
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (imageBase64.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createElementVNode("img", {
                            src: imageBase64.value,
                            alt: "Lista cargada",
                            class: "uploaded-image"
                          }, null, 8, _hoisted_4)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(_component_v_file_input, {
                            ref_key: "fileInput",
                            ref: fileInput,
                            label: "Selecciona una imagen",
                            onChange: onImageSelected,
                            accept: "image/*"
                          }, null, 512)
                        ]))
                  ]))
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { style: {"display":"flex","justify-content":"space-between"} }, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              (imageBase64.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_v_btn, {
                      variant: "tonal",
                      color: "primary",
                      onClick: cambiarImagen
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cambiar")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      variant: "tonal",
                      color: "primary",
                      onClick: enviarLista,
                      disabled: isSendButtonDisabled.value,
                      style: {"margin-right":"10px"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Enviar")
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_btn, {
                variant: "tonal",
                color: "secondary",
                onClick: close,
                style: {"margin-left":"auto"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cancelar")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})